
import React from 'react';
import { Link } from 'react-router-dom';
import './Common_breadcrumb.css';

const Common_breadcrumb = ({ items }) => {
    return (
        <div className='Common_breadcrumb_sec'>
            <div className='container breadcrumb-container'>
                {items?.map((item, index) => (
                    <span key={index} className="breadcrumb-item popname">
                        {item.link ? (
                            <Link to={item.link}>{item.label}</Link>
                        ) : (
                            <span>{item.label}</span>
                        )}

                        {index !== items.length - 1 && (
                            <span className="breadcrumb-separator "> / </span>
                        )}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default Common_breadcrumb;
